import React, { useEffect } from 'react';

import registerAnimations from './registerAnimations';
import TrustpilotWidget from '../TrustpilotWidget/TrustpilotWidget';
import './LandingPageMerinoRunners.scss';

import ShoesUltraLightWeight from '../../static/images/merinorunners/shoes-ultra-light-weight.png';
import Feather1 from '../../static/images/merinorunners/feather-1.png';
import Feather2 from '../../static/images/merinorunners/feather-2.png';
import Feather3 from '../../static/images/merinorunners/feather-3.png';
import Feather4 from '../../static/images/merinorunners/feather-4.png';
import Feather5 from '../../static/images/merinorunners/feather-5.png';
import Feather6 from '../../static/images/merinorunners/feather-6.png';

import ShoesColorSet1 from '../../static/images/merinorunners/shoes-color-set-1.png';
import ShoesColorSet2 from '../../static/images/merinorunners/shoes-color-set-2.png';
import ShoesColorSet3 from '../../static/images/merinorunners/shoes-color-set-3.png';
import ShoesColorSet4 from '../../static/images/merinorunners/shoes-color-set-4.png';

import sec3Poster from '../../static/images/merinorunners/temperature_final.jpg' 
import sec3Video from '../../static/images/merinorunners/temperature_final.mp4';

import WaterDropFall from '../../static/images/merinorunners/water-drop-fall.png';
import WaterDrop1 from '../../static/images/merinorunners/water-drop-1.png';
import WaterDrop2 from '../../static/images/merinorunners/water-drop-2.png';
import WaterDrop3 from '../../static/images/merinorunners/water-drop-3.png';

import MerinoWool from '../../static/images/merinorunners/merino-wool.jpg';

import quote from '../../static/images/quote.png';

const LandingPageMerinoRunners = ({
  headerBackgroundMobile,
  headerBackground,
  headerText,
  headerTextSmall,
  headerPrice,
  headerButton1Text,
  headerButton1Url,
  headerButton2Text,
  headerButton2Url,
  sec1Text,
  sec1Button1Text,
  sec1Button1Url,
  sec1Button2Text,
  sec1Button2Url,
  sec2Text,
  sec2BackgroundMobile,
  sec2Background,
  sec3Text,
  sec4Text,
  sec4Button1Text,
  sec4Button1Url,
  sec4Button2Text,
  sec4Button2Url,
  sec4Details1,
  sec4Details2,
  sec4Details3,
  sec4Details4,
  sec5Text,
  sec5ButtonText,
  sec5ButtonUrl,
  sec5BackgroundMobile,
  sec5Background,
  sec6Text,
  sec6BackgroundMobile,
  sec6Background,
  sec7BackgroundMobile,
  sec7Background,
  sec7Text,
  sec7ButtonUrl,
  sec7ButtonText,
  sec8Text,
  sec8Image,
  sec8Button1Text,
  sec8Button1Url,
  sec8Button2Text,
  sec8Button2Url,
}) => {
  
  useEffect(() => {
    registerAnimations();
  }, []);

  return (
    <div className="landingpage-merino-runners">
      <main className="contents">

        {/* Header */}

        <style>
          {`
            .landingpage-merino-runners .banner {
              background-image: url(${headerBackgroundMobile});
            }

            @media (min-width: 992px) {
              .landingpage-merino-runners .banner {
                background-image: url(${headerBackground});
              }
            }
          `}
        </style>

        <section className="banner">
          <div className="container">
            <article className="content clearfix">
              {headerText}
              <p className="quality quality-inline d-md-none">{headerTextSmall}</p>
            </article>
          </div>
          <div className="cta">
            <div className="container px-0 px-md-3">
              <div className="clearfix mb-4 d-none d-md-block">
                <p className="quality float-left">{headerTextSmall}</p>
                <span className="d-md-block h2 price pb-3">{headerPrice}</span>
              </div>
              <div className="row compact btn-cont">
                <div className="col-6"><a href={headerButton1Url} className="btn btn-light btn-block mb-3 d-none d-md-block">{headerButton1Text}</a><a href={headerButton1Url} className="btn btn-dark btn-block mb-3 d-md-none">{headerButton1Text}</a></div>
                <div className="col-6"><a href={headerButton2Url} className="btn btn-light btn-block mb-3 d-none d-md-block">{headerButton2Text}</a><a href={headerButton2Url} className="btn btn-dark  btn-block mb-3 d-md-none">{headerButton2Text}</a></div>
              </div>
            </div>
          </div>
        </section>

        {/* Section 1 */}

        <section className="sec sec5 pb-0">
          <div className="container">
            <div className="row">
              <article className="content col-11 col-md-7 col-lg-7 col-xl-7">
                {sec1Text}
              </article>
              <figure className="col-12 col-md-5 feathers">
                <img src={ShoesUltraLightWeight} className="shoe" alt="" />
                <img src={Feather1} alt="alt" className="feather feather-1 hide animated" />
                <img src={Feather2} alt="alt" className="feather feather-2 hide animated delay-1" />
                <img src={Feather3} alt="alt" className="feather feather-3 hide animated delay-2" />
                <img src={Feather4} alt="alt" className="feather feather-4 hide animated delay-5" />
                <img src={Feather5} alt="alt" className="feather feather-5 hide animated delay-4" />
                <img src={Feather6} alt="alt" className="feather feather-6 hide animated delay-3" />
              </figure>
            </div>
          </div>
          <p className="text-center shoes-color-sets mt-xl-5">
            <img src={ShoesColorSet1} alt="" className="shoes-color-set-1 hide animated animatedUp" />
            <img src={ShoesColorSet2} alt="" className="shoes-color-set shoes-color-set-2 hide animated animatedDown delay-1" />
            <img src={ShoesColorSet3} alt="" className="shoes-color-set shoes-color-set-3 hide animated animatedUp delay-2" />
            <img src={ShoesColorSet4} alt="" className="shoes-color-set shoes-color-set-4 hide animated animatedDown delay-3" />
          </p>
          <p className="py-4 py-lg-5 mb-md-5 text-center">
            <a href={sec1Button1Url} className="btn btn-dark mb-3 mr-2">{sec1Button1Text}</a>
            <a href={sec1Button2Url} className="btn btn-dark mb-3 ml-2">{sec1Button2Text}</a>
          </p> 
        </section> 

        {/* Section 2 */}

        <style>
          {`
            .landingpage-merino-runners .sec3 {
              background-image: url(${sec2BackgroundMobile});
            }

            @media (min-width: 992px) {
              .landingpage-merino-runners .sec3 {
                background-image: url(${sec2Background});
              }
            }
          `}
        </style>

        <section className="sec sec3">
          <div className="container">
            <div className="row">
              <article className="content col-11 col-sm-9 col-md-7 col-lg-5 col-xl-5">
                {sec2Text}
              </article>
            </div>
          </div>
        </section>

        {/* Section 3 */}
        
        <section className="py-3 px-0 p-md-4 p-lg-5">
          <div className="container-fluid sec sec4 p-4 p-sm-5 p-lg-5 sweetingCont">
            <div className="video-background">
              <video className="video" autoPlay playsInline loop muted width="100%" height="100%" poster={sec3Poster}><source src={sec3Video} type="video/mp4" /></video>
            </div>
            <div className="row">
              <article className="content col-10 col-sm-8 col-md-6 col-lg-5  pt-5 pb-5 pb-lg-4   mt-lg-5 mb-lg-5 pl-lg-5 ">
                {sec3Text}
              </article>	
            </div>
            <figure className="sweeting">
              <img src={WaterDropFall} alt="" className="water-drop-fall hide animated" />
              <img src={WaterDrop1} alt="" className="water-drop water-drop-1 hide animated delay-2" />
              <img src={WaterDrop2} alt="" className="water-drop water-drop-2 hide animated delay-3" />
              <img src={WaterDrop3} alt="" className="water-drop water-drop-3 hide animated delay-3" />
            </figure>
          </div>
        </section>

        {/* Section 4 */}

        <section className="sec sec9 py-5">
          <div className="container">
            <h2 className="text-center">{sec4Text}</h2>
            <p className="mt-5 text-center">
            <a href={sec4Button1Url} className="btn btn-dark mb-3 mr-2">{sec4Button1Text}</a>
            <a href={sec4Button2Url} className="btn btn-dark mb-3 ml-2">{sec4Button2Text}</a>
            </p>
            <div className="sole-features-outer clearfix">
              <figure className="sole-features-feathers">
                <img src={Feather2} alt="alt" className="feather feather-1 hide animated" />
                <img src={Feather5} alt="alt" className="feather feather-2 hide animated delay-1" />
                <img src={Feather6} alt="alt" className="feather feather-3 hide animated delay-2" />
              </figure>		
              <div className="sole-features-cont clearfix">
                <p className="shoe-sole"><img src={MerinoWool} alt="" /></p>
                <ul className="sole-features">  
                  <li><em><span>{sec4Details1}</span></em></li>
                  <li><em><span>{sec4Details2}</span></em></li>
                  <li><em><span>{sec4Details3}</span></em></li>
                  <li><em><span>{sec4Details4}</span></em></li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Section 5 */}

        <section className="sec sec10 footbed">
          <div className="container">
            <div className="row">
              <article className="content-2 col-12 col-md-6 col-lg-6 col-xl-5  mb-lg-0 ml-md-auto order-md-2">
                {sec5Text}
                <p><a href={sec5ButtonUrl} className="btn btn-dark">{sec5ButtonText}</a></p>
              </article>
              <figure className="col-12 col-md-6 order-md-1">
                <p className="hide animated">
                  <img src={sec5BackgroundMobile} alt="" className="d-md-none footbed-img-sm" />
                  <img src={sec5Background} alt="" className="d-none d-md-block footbed-img" />
                </p>
              </figure>
            </div>
          </div>
        </section>

        {/* Section 6 */}

        <style>
          {`
            .landingpage-merino-runners .sec11 {
              background-image: url(${sec6BackgroundMobile});
            }

            @media (min-width: 992px) {
              .landingpage-merino-runners .sec11 {
                background-image: url(${sec6Background});
              }
            }
          `}
        </style>

        <section className="sec sec11">
          <div className="container">
            <div className="row">
              <article className="content col-8 col-md-6 col-lg-5 col-xl-4  mb-lg-0">
                {sec6Text}
              </article>
            </div>
          </div>
        </section>

        {/* Section 7 */}

        <style>
          {`
            .landingpage-merino-runners .sec12 {
              background-image: url(${sec7BackgroundMobile});
            }

            @media (min-width: 992px) {
              .landingpage-merino-runners .sec12 {
                background-image: url(${sec7Background});
              }
            }
          `}
        </style>

        <section className="sec sec12">
          <div className="container">
            <div className="row">
              <article className="content col-11 col-md-6 col-lg-5 col-xl-4  mb-lg-0 ml-md-auto">
                {sec7Text}
                <p className="d-lg-block pt-3"><a href={sec7ButtonUrl} className="btn btn-outline-light">{sec7ButtonText}</a></p>
              </article>
            </div>
          </div>
        </section>

        {/* Section 8 */}

        <section className="sec py-5 testimonials">
          <div className="container">
            <p className="text-center qoute pb-4"><img src={quote} alt="" /></p>
          </div>
          <div className="trustBox-widget py-4 py-lg-5 mb-5">
            <div className="container">
              <TrustpilotWidget />
            </div>
          </div>
          <div className="testimonials-products">
            <div className="container">
              <div className="row">
                <figure className="d-none d-md-block col-12 col-md-5">
                  <p><img src={sec8Image} alt="" /></p>
                </figure>
                <article className="content col-12 col-md-7 mb-lg-0 ml-md-auto">
                  {sec8Text}
                  <figure className="d-md-none"><img src={sec8Image} alt="" /></figure>
                  <p className="btn-cont mt-5 text-center text-md-left">
                    <a href={sec8Button1Url} className="btn btn-dark  d-md-inline-block mb-3 mr-1">{sec8Button1Text}</a>
                    <a href={sec8Button2Url} className="btn btn-dark  d-md-inline-block mb-3">{sec8Button2Text}</a>
                  </p>
                </article>
              </div>
            </div>
          </div>
        </section>
      </main>

    </div>
  )
}

LandingPageMerinoRunners.defaultProps = {
  headerBackgroundMobile: 'http://rothierdesign.com/projects/giesswein/merinorunners/images/banner-sm.jpg',
  headerBackground: 'http://rothierdesign.com/projects/giesswein/merinorunners/images/banner.jpg',
  headerText: <><h1><strong>MERINO</strong><br/>RUNNERS</h1></>,
  headerTextSmall: '100% Merino Wool',
  headerPrice: '€129',
  headerButton1Text: 'WOMEN',
  headerButton1Url: '#',
  headerButton2Text: 'MEN',
  headerButton2Url: '#',

  sec1Text: <><h2><strong>Discover our <br /> ultra-lightweight </strong><br className="d-none d-lg-block" /> made of merino wool.</h2>
    <p>Float over the streets with the Merino Runners! The flexible EVA sole and the total weight of only 500 g ensure a feather-light, comfortable feeling.</p>
    <ul className="bullet">
      <li>100% Merino wool inside and outside</li>
      <li>Interchangeable footbed in merino wool</li>
      <li>Extra light and flexible Eva sole</li>
    </ul></>,
  sec1Button1Text: 'WOMEN',
  sec1Button1Url: '#',
  sec1Button2Text: 'MEN',
  sec1Button2Url: '#',

  sec2Text: <><h2>Unique  <br /> Merino Wool  <br /> <strong>3D stretch.</strong></h2>
    <h3>Feels like a second skin.</h3>
    <p>Thanks to the specially developed 3D knitting technology, the Merino Runner adapts perfectly to your foot. It combines flexibility with stability and guarantees exceptional comfort all year round.</p></>,
  sec2BackgroundMobile: 'http://rothierdesign.com/projects/giesswein/merinorunners/images/bg-sec3-sm.jpg',
  sec2Background: 'http://rothierdesign.com/projects/giesswein/merinorunners/images/bg-sec3.jpg',

  sec3Text: <><h2>Sweating is   <br /> a thing of  <br /> the past.</h2>
    <p>Wear the Merino Runner even without socks - without sweating. The natural merino wool is breathable and temperature regulating. </p></>,
  
  sec4Text: <>MERINO <strong>WOOL</strong></>,
  sec4Button1Text: 'WOMEN',
  sec4Button1Url: '#',
  sec4Button2Text: 'MEN',
  sec4Button2Url: '#',
  sec4Details1: <><strong>Odourless</strong> <br /> Merino wool fights bacteria. The surface structure prevents bacteria from settling in. So even in warm temperatures you are spared from bad odours.</>,
  sec4Details2: <><strong>Made of 100 % merino wool</strong> <br /> A highly comfortable, replaceable footbed made of 100 % merino wool. Provides a pleasantly soft skin feeling.</>,
  sec4Details3: <><strong>Innovative sole system</strong> <br />  Flexible EVA material ensures a feather-light feeling when walking. The slightly raised heel enhances the wearing comfort. The grooved profile always gives you a good grip.</>,
  sec4Details4: <><strong>Summer and winter</strong> <br />  Your feet neither get too warm nor too cold - merino wool makes sure of that. Because the natural air chambers in the wool have a temperature regulating effect!</>,

  sec5Text: <><h2>INTERCHANGEABLE <br /> <strong>FOOTBED</strong></h2>
    <h3>Made of 100 % merino wool.</h3>
    <p>A highly comfortable, replaceable footbed made of 100% merino wool. Provides a pleasantly soft skin feeling.</p></>,
  sec5ButtonText: 'Buy Footbed',
  sec5ButtonUrl: '#',
  sec5BackgroundMobile: 'http://rothierdesign.com/projects/giesswein/merinorunners/images/bg-sec10-sm.jpg',
  sec5Background: 'http://rothierdesign.com/projects/giesswein/merinorunners/images/footbed.jpg',

  sec6Text: <><h2>Simply wash <br /> in the <strong>washing <br /> machine. </strong></h2>
    <p>You can wash your Merino Runner in the washing machine (cold water, 30°C, wool wash cycle, no fabric softener) Then let the shoes air dry (not in the dryer). Et voilà - they look like new.</p></>,
  sec6BackgroundMobile: 'http://rothierdesign.com/projects/giesswein/merinorunners/images/bg-sec11-sm.jpg',
  sec6Background: 'http://rothierdesign.com/projects/giesswein/merinorunners/images/bg-sec11_new.jpg',

  sec7Text: <><h2><strong>Green</strong> <br /> Strategy</h2>
    <p>Throughout the three generations of our company’s family owned and operated business, we’ve learned to combine our knowledge of wool craftsmanship with modern, green thinking about the environment and animal protection</p></>,
  sec7ButtonText: 'Know More',
  sec7ButtonUrl: '#',
  sec7BackgroundMobile: 'http://rothierdesign.com/projects/giesswein/merinorunners/images/bg-sec12-sm.jpg',
  sec7Background: 'http://rothierdesign.com/projects/giesswein/merinorunners/images/bg-sec12.jpg',

  sec8Text: <><h3><strong>These Clients bought this shoe,</strong>  <br className="d-none d-md-block" /> Maybe try this one too</h3></>,
  sec8Image: 'http://rothierdesign.com/projects/giesswein/merinorunners/images/shoe-yellow-2.jpg',
  sec8Button1Text: 'WOMEN',
  sec8Button1Url: '#',
  sec8Button2Text: 'MEN',
  sec8Button2Url: '#',
}

export default LandingPageMerinoRunners;